export const WORKFLOW_NODE_DRAG_TYPE = 'application/reactflow';

export const WORKFLOW_ADDABLE_NODE_TYPES = [
  {
    type: 'html',
    label: 'Instruction',
    icon: 'bi-file-text',
    color: '#fd7e14',
    description:
      'Display text instructions and navigation buttons for the engineer.',
  },
  {
    type: 'form',
    label: 'Form',
    icon: 'bi-ui-checks',
    color: '#198754',
    description: 'Collect structured data using a form definition.',
  },
  {
    type: 'photo',
    label: 'Photo',
    icon: 'bi-camera',
    color: '#6f42c1',
    description:
      'Prompt the engineer to capture a photo with optional instructions.',
  },
];

function getNodeTypeConfig(type) {
  return WORKFLOW_ADDABLE_NODE_TYPES.find((entry) => entry.type === type) || WORKFLOW_ADDABLE_NODE_TYPES[0];
}

function normalizeStepType(stepType) {
  const normalized = (stepType || 'html').toLowerCase();
  if (normalized === 'form') return 'form';
  if (normalized === 'photo') return 'photo';
  return 'html';
}

export function getStepIconConfig(stepType) {
  return getNodeTypeConfig(normalizeStepType(stepType));
}
